const urlApiDev = process.env.API_BASE_URL_DEV
const urlApiProd = process.env.API_BASE_URL

const isDev = [
  'localhost',
  'homologacao.senhadigitalplus.com.br',
  'homologacao.certificadorapadrao.com.br',
  'link.senhadigitalplus.com.br',
].includes(window.location.hostname)

const urlApi = isDev ? urlApiDev : urlApiProd

const storedNameCupomDiscount = localStorage.getItem('name_cupom_Discount')

export const state = () => ({
  cupom: [],
  name_cupom_Discount: storedNameCupomDiscount
    ? JSON.parse(storedNameCupomDiscount)
    : null,
})

export const getters = {
  allInfoCupom: (state) => state.name_cupom_Discount,
  descontoDoCupom: (state) => (valorVenda) => {
    const valorCupom = state.name_cupom_Discount
      ? state.name_cupom_Discount.valor
      : 0
    if (valorCupom && typeof valorCupom === 'number' && valorCupom > 0) {
      const desconto = (valorCupom / 100) * valorVenda
      const valorComDesconto = valorVenda - desconto
      return valorComDesconto
    } else {
      return valorVenda
    }
  },
}

export const mutations = {
  GET_CUPOM_DISCOUNUT(state, payload) {
    state.name_cupom_Discount = payload
    localStorage.setItem(
      'name_cupom_Discount',
      JSON.stringify(state.name_cupom_Discount)
    )
  },
  CLEAN_CUPOM(state) {
    state.name_cupom_Discount = null
    localStorage.removeItem('name_cupom_Discount')
  },
}

export const actions = {
  async getCupomDiscount({ commit }, cupom) {
    const instance = await this.$axios.create({
      baseURL: urlApi,
    })
    const data = await instance.get('/cupom/v1/' + cupom)
    commit('GET_CUPOM_DISCOUNUT', data.data)
    return data
  },
}
